import React from 'react';
import { ISearchFilters, ISearchResults } from '@components/pages/ShopV3/model/SearchResults';
import classNames from 'classnames';
import { useTheme } from '@components/theme';
import SortByMobile from '@components/pages/ShopV3/components/SortByMobile/SortByMobile';
import { isEmpty } from 'lodash';
import If from '@components/shared/conditional/If/If';
import FacetFilter from '@components/pages/ShopV3/components/Filters/FacetFilter/FacetFilter';
import AttributeFamilyFilters, {
  IAttributeFamilies,
} from '../Filters/AttributeFamilyFilter/AttributeFamilyFilters';
import styles from './MobileFilters.module.scss';
import { ShopPageType } from '../../model/ShopPage';

interface IMobileFiltersProps {
  className?: string;
  filters: ISearchFilters;
  searchResults: ISearchResults;
  shopPageType: ShopPageType;
  onToggleMobileFilters: () => void;
  isExpanded: boolean;
  attributeFamilies: IAttributeFamilies;
  onClearAll: () => void;
}

const MobileFilters = ({
  searchResults,
  shopPageType,
  onToggleMobileFilters,
  filters: { selectedShopGroupChain = [], selectedMerchGroup },
  isExpanded,
  attributeFamilies: {
    attributeFamilyFilters,
    selectedFilterIds,
    onFilterSelected
  },
  onClearAll
}: IMobileFiltersProps) => {
  const theme = useTheme();

  return (
    <div className={styles.Wrapper}>
      <div className={styles.TopControls}>
        <button
          type={'button'}
          className="havenly-icon close"
          onClick={() => onToggleMobileFilters()}
        />
        <span>Filter By:</span>
        <button
          type="button"
          className={styles.ClearButton}
          onClick={onClearAll}
        >
          Clear
        </button>
      </div>

      <hr />

      <SortByMobile />

      <If condition={
        shopPageType === ShopPageType.MERCH_GROUP ||
        shopPageType === ShopPageType.MERCH_GROUP_CATEGORY
        }
      >
        <AttributeFamilyFilters
          attributeFamilyFilters={attributeFamilyFilters}
          selectedFilterIds={selectedFilterIds}
          onFilterSelected={onFilterSelected}
        />
      </If>

      <If
        condition={
          !isEmpty(searchResults.facets) && !selectedMerchGroup && !selectedShopGroupChain.length
        }
      >
        <div
          className={classNames({
            [styles.Transparent]: !isExpanded,
            [styles.Facets]: isExpanded,
          })}
        >
          <If condition={!!searchResults.facets?.price}>
            <FacetFilter facet={searchResults.facets.price} />
          </If>
          <If condition={!!searchResults.facets?.vendor}>
            <FacetFilter facet={searchResults.facets.vendor} />
          </If>
          <If condition={!!searchResults.facets?.category}>
            <FacetFilter facet={searchResults.facets.category} />
          </If>
        </div>
      </If>

      <div className={styles.BottomControls}>
        <button
          type="button"
          className={classNames(
            theme.styles.Button,
            theme.styles.Primary,
            styles.Fluid,
          )}
          onClick={() => onToggleMobileFilters()}
        >
          View results
        </button>
      </div>
    </div>
  );
};

export default MobileFilters;
